/* eslint-disable object-shorthand */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
import { createAsyncThunk, createSlice, isAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL_API, LOCAL_STORAGE, UserInterface } from '../constants/constants';
import { request } from '../utility/utility';
import { LoginInterface } from '../pageParts/popUp/popUpTypes';

interface AdminUserInterface {
  id: number;
  name: string;
  email: string;
  lastOnline: number;
  admin: boolean;
}

export type UserDataInterface = {
  isLogin: boolean;
  user: UserInterface;
  error: string | null | undefined;
  totalUsers: number;
  users: AdminUserInterface[] | null;
};

type userDataRequest = {
  name?: string;
  email: string;
  password: string;
};

export const factoryReset = createAsyncThunk(
  'userData/factoryReset',
  async () => {
    const token = localStorage.getItem(LOCAL_STORAGE.TOKEN);
    const response = await request('/factory-reset', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return response;
  }
);

const fakeLogout = (
  url: string,
  options: { method: string; headers: any; body: string }
) =>
  new Promise<{ message: string }>((resolve, reject) => {
    setTimeout(() => {
      if (options.method === 'POST' && url === '/logout') {
        const bodyData = JSON.parse(options.body);
        if (bodyData.token) {
          resolve({ message: 'Logout successful' });
        } else {
          reject(new Error('Invalid token'));
        }
      } else {
        reject(new Error('Invalid URL or method'));
      }
    }, 1000);
  });

export const signin = createAsyncThunk(
  'userData/login',
  async (bodyData: LoginInterface) => {
    console.log(bodyData);
    const response = await request('/signin', {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(bodyData),
    });

    return { response, password: bodyData.password };
  }
);

export const signup = createAsyncThunk(
  'userData/registration',
  async (bodyData: userDataRequest) => {
    const response = await request('/signup', {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(bodyData),
    });

    return { response, password: bodyData.password };
  }
);

export const signOut = createAsyncThunk(
  'userData/logout',
  async (bodyData: { token: string | null }) => {
    console.log(bodyData);

    return fakeLogout('/logout', {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(bodyData),
    });
  }
);

export const updateProfile = createAsyncThunk(
  'userData/profile',
  async (formData: FormData, { getState }) => {
    const state = getState() as any;
    const param = state.userData.user.id;
    const response = await axios.patch(
      `${BASE_URL_API}/profile/${param}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  }
);

export const userReset = createAsyncThunk('userData/reset', async () => {
  const response = await request('/reset-users', {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
  return response;
});

export const countUsers = createAsyncThunk('userData/count', async () => {
  const response = await request('/total-users', {
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
  return response;
});

export const getAllUsers = createAsyncThunk('userData/getAll', async () => {
  const response = await request('/admin-users', {
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
  return response;
});

export const deleteUser = createAsyncThunk(
  'userData/delete',
  async (userId: number) => {
    console.log(`****${userId}****`);
    const response = await request(`/delete-user/${userId}`, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response;
  }
);

export const findUser = createAsyncThunk(
  'userData/find',
  async (email: string) => {
    const response = await request(`/user/${email}`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response;
  }
);

const initialState: UserDataInterface = {
  isLogin:
    JSON.parse(localStorage.getItem(LOCAL_STORAGE.ISLOGIN) as string) || false,
  user: JSON.parse(localStorage.getItem(LOCAL_STORAGE.USER) as string) || {
    id: 0,
    name: '',
    email: '',
    avatar: '',
    admin: null,
  },
  error: null,
  totalUsers: 0,
  users: null,
};

const userData = createSlice({
  name: 'UserData',
  initialState,
  reducers: {
    setAuthorization: (state, action) => {
      state.isLogin = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // login
      .addCase(signin.fulfilled, (state, action) => {
        const data = action.payload.response;
        console.log(data);
        const { password } = action.payload;
        const token = data.token.access_token;
        console.log(token);
        const { user } = data;
        localStorage.setItem(LOCAL_STORAGE.TOKEN, token);
        localStorage.setItem(LOCAL_STORAGE.PASSWORD, password);
        localStorage.setItem(LOCAL_STORAGE.ISLOGIN, JSON.stringify(true));
        localStorage.setItem(LOCAL_STORAGE.USER, JSON.stringify(user));
        state.user = user;
        state.isLogin = true;
      })
      .addCase(signin.rejected, (state, action) => {
        const err = action.payload as string;
        state.error = action.error.message;
        console.log(state.error);
      })

      // signup
      .addCase(signup.fulfilled, (state, action) => {
        const data = action.payload.response;
        const { password } = action.payload;
        const token = data.access_token.access_token;
        console.log(token);
        const { user } = data;
        localStorage.setItem(LOCAL_STORAGE.TOKEN, token);
        localStorage.setItem(LOCAL_STORAGE.PASSWORD, password);
        localStorage.setItem(LOCAL_STORAGE.ISLOGIN, JSON.stringify(true));
        localStorage.setItem(LOCAL_STORAGE.USER, JSON.stringify(user));
        state.error = null;
        state.user = user;
        state.isLogin = true;
      })
      .addCase(signup.rejected, (state, action) => {
        console.error('Error:', action.error.message);
      })

      // logout
      .addCase(signOut.fulfilled, (state, action) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const data = action.payload;
        const user = {
          id: 0,
          name: '',
          email: '',
          avatar: null,
          admin: null,
        };

        localStorage.removeItem(LOCAL_STORAGE.TOKEN);
        localStorage.setItem(LOCAL_STORAGE.ISLOGIN, JSON.stringify(false));
        state.isLogin = false;
        localStorage.setItem(LOCAL_STORAGE.USER, JSON.stringify(user));
        state.user = user;
      })
      .addCase(signOut.rejected, (state, action) => {
        console.error('Error:', action.error.message);
      })
      .addCase(updateProfile.fulfilled, (state, actiion) => {
        const data = actiion.payload;
        state.user = data;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        console.log('err update');
      })
      .addCase(factoryReset.fulfilled, (state, action) => {
        state.isLogin = false;
      })
      .addCase(userReset.fulfilled, (state, action) => {
        const data = action.payload.response;
        const { password } = action.payload;
        const token = data.access_token.access_token;
        console.log(token);
        const { user } = data;
        localStorage.setItem(LOCAL_STORAGE.TOKEN, token);
        localStorage.setItem(LOCAL_STORAGE.PASSWORD, password);
        localStorage.setItem(LOCAL_STORAGE.ISLOGIN, JSON.stringify(true));
        localStorage.setItem(LOCAL_STORAGE.USER, JSON.stringify(user));
        state.error = null;
        state.user = user;
        state.isLogin = true;
      })
      .addCase(countUsers.fulfilled, (state, action) => {
        const totalUsers = action.payload;
        state.totalUsers = totalUsers;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        const users = action.payload;
        state.users = users;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        const users = action.payload;
        state.users = users;
      })
      .addCase(findUser.fulfilled, (state, action) => {
        const users = action.payload;
        state.users = users;
      });
  },
});

export const { setUser, setAuthorization, setError } = userData.actions;
export default userData;
